module.exports = "/_next/static/images/LowRecencyPurchaseWinbackMobile-8c648d6f34989e68356f3925b3fecae8.webp";